<template>
  <div>
    <el-divider>字段关联</el-divider>
    <field-setting v-model="mapPrjNameTo" v-bind="$props" label="关联项目名称"></field-setting>
    <field-setting v-model="mapPrjCodeTo" v-bind="$props" label="关联项目编号"></field-setting>
  </div>
</template>

<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";

export default {

  mixins: [settingMixin],
  data() {
    return {
    };
  },

  computed: {
    ...mapVFOptions("mapPrjNameTo", "mapPrjCodeTo")
  },

  methods: {

  }
};
</script>
